export default "__VITE_ASSET__844457d7__"